import { TFunction } from 'i18next'
import { ComponentType, IMenuItem } from 'meta/backendControlled/structure'
import { PerformerType } from 'meta/pages/performer'
import {
  IPerformerData,
  IPerformerDataActiveEvents,
  IPerformerDataActiveTypeticketcollections,
  IPerformerMetadata
} from 'meta/pages/v4/performer'

export const getPerformersMenuItems = (
  details: IPerformerData,
  activeEvents: {
    data: Record<number, IPerformerDataActiveEvents>
    metadata: IPerformerMetadata
  },
  activeTypeticketCollections: {
    data: Record<number,IPerformerDataActiveTypeticketcollections>
    metadata: IPerformerMetadata
  },
  t: TFunction): IMenuItem[] => {
  const menuItems: IMenuItem[] = []

  if (!details) {
    return menuItems
  }

  if (activeTypeticketCollections.metadata.total > 0) {
    menuItems.push({
      title: t('collection:season_tickets_title'),
      anchor: 'abbonamenti',
      componentType: ComponentType.map,
    })
  }

  if (activeEvents.metadata.total > 0) {
    menuItems.push({
      title: t('collection:event_title'),
      anchor: 'eventi',
      componentType: ComponentType.map,
    })
  }

  if (details.bio) {
    menuItems.push({
      title: t(isPerformerArtist(details.type.key.toUpperCase() as PerformerType) ? 'collection:biography' : 'collection:info_history_title'),
      anchor: 'info',
      componentType: ComponentType.map,
    })
  }

  return menuItems
}

export const isPerformerArtist = (type: PerformerType): boolean => {
  return [PerformerType.ACTOR, PerformerType.BAND, PerformerType.SINGER].includes(type)
}
